import { render, staticRenderFns } from "./FieldPhoneNumber.vue?vue&type=template&id=27d09ce8&"
import script from "./FieldPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./FieldPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./FieldPhoneNumber.vue?vue&type=style&index=0&id=27d09ce8&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports